import { z } from 'zod';
import {
  LINK_CARD_TARGET_BOARD_TITLE_CACHE_MAX_LENGTH,
  LINK_CARD_TARGET_TITLE_CACHE_MAX_LENGTH,
  LINK_CARD_TARGET_URL_MAX_LENGTH,
} from './board-contents';
export {
  LINK_CARD_TARGET_BOARD_TITLE_CACHE_MAX_LENGTH,
  LINK_CARD_TARGET_TITLE_CACHE_MAX_LENGTH,
  LINK_CARD_TARGET_URL_MAX_LENGTH,
  boardFaceCardSurfaceSchema,
  boardFaceLinkCardSurfaceSchema,
  boardFaceOrdinaryCardSurfaceSchema,
  cardMirrorSchema,
  cardMirrorSourceBoardSchema,
  type BoardFaceCardSurface,
  type BoardFaceLinkCardSurface,
  type BoardFaceOrdinaryCardSurface,
  type CardMirror,
  type CardMirrorSourceBoard,
} from './board-contents';
import { cardSchema } from './card';
import { cardDetailSchema } from './card-detail';
import { ulidSchema } from './id';

const surfaceNeighbourSchema = ulidSchema.nullable().default(null);

export const cardMirrorCreateBodySchema = z.strictObject({
  listId: ulidSchema,
  previousSurfaceId: surfaceNeighbourSchema,
  nextSurfaceId: surfaceNeighbourSchema,
});

export type CardMirrorCreateBody = z.infer<typeof cardMirrorCreateBodySchema>;

export const linkCardSchema = cardSchema.extend({
  isLinkCard: z.literal(true),
  linkTargetUrl: z.string().min(1).max(LINK_CARD_TARGET_URL_MAX_LENGTH),
  linkTargetTitleCache: z
    .string()
    .min(1)
    .max(LINK_CARD_TARGET_TITLE_CACHE_MAX_LENGTH)
    .nullable(),
  linkTargetBoardTitleCache: z
    .string()
    .min(1)
    .max(LINK_CARD_TARGET_BOARD_TITLE_CACHE_MAX_LENGTH)
    .nullable()
    .optional(),
  linkTargetUnavailable: z.boolean().optional(),
});

export type LinkCard = z.infer<typeof linkCardSchema>;

export const cardCreateResultSchema = z.union([linkCardSchema, cardSchema]);

export type CardCreateResult = z.infer<typeof cardCreateResultSchema>;

export const linkCardConvertResultSchema = cardDetailSchema;

export type LinkCardConvertResult = z.infer<typeof linkCardConvertResultSchema>;
